/*
 * hpn-sale-tage.js
 * HPN Week im Startseiten-Hero (Sami 23.09.2026). Zeigt von den Varianten in
 * [data-hpn-sale-tage] genau eine: den Sale-Tag, dessen Zeitraum gerade
 * läuft, sonst den normalen Hero (data-hpn-variante="standard").
 *
 * Der Server wählt den Tag schon beim Rendern (sections/hpn-startseite-hero.liquid).
 * Dieses Skript ist die zweite Stufe für drei Fälle, die der Server nicht
 * sieht: ein Tab, der über den Tageswechsel offen bleibt, die
 * Vorschau-Parameter und den Theme-Editor.
 *
 * Zeiten: data-start und data-ende sind Unix-Sekunden, von Liquid in der
 * Zeitzone des Shops (Europe/Berlin) gerechnet. Der Vergleich mit Date.now()
 * hängt deshalb nicht von der Zeitzone des Besuchers ab.
 *
 * Vorschau:
 *   ?sale_tag=26.09.            zeigt den Tag mit diesem Startdatum
 *   ?sale_zeit=2026-09-26T00:05  tut so, als wäre es diese deutsche Uhrzeit
 * Theme-Editor: ein angeklickter Block zeigt seinen Tag.
 *
 * Die Knöpfe stellt Datora um (snippets/datora.js.liquid), auch in
 * versteckten Varianten. Hier wird nur ein- und ausgeblendet.
 */
(function () {
  'use strict';

  /* Deutsche Wanduhrzeit "2026-09-26T00:05" in Millisekunden, unabhängig von
     der Zeitzone des Rechners. Nur für ?sale_zeit, am 23.09. in Berlin, New
     York und Tokio nachgerechnet, auch über die Winterzeit. */
  function berlinZuMs(text) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(String(text).trim());
    if (!m) return NaN;
    var alsUtc = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
    var teile = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Berlin', hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
    }).formatToParts(new Date(alsUtc));
    var w = {};
    teile.forEach(function (p) { w[p.type] = p.value; });
    var berlinAlsUtc = Date.UTC(+w.year, +w.month - 1, +w.day, +w.hour, +w.minute);
    return alsUtc - (berlinAlsUtc - alsUtc);
  }

  var parameter = new URLSearchParams(window.location.search);
  var erzwungenerTag = parameter.get('sale_tag');
  var simulierteZeit = parameter.get('sale_zeit');
  var simulierteMs = simulierteZeit ? berlinZuMs(simulierteZeit) : NaN;

  function jetztSekunden() {
    return (isNaN(simulierteMs) ? Date.now() : simulierteMs) / 1000;
  }

  function einrichten(wurzel) {
    if (!wurzel || wurzel.dataset.hpnSaleTageBereit === '1') return;
    wurzel.dataset.hpnSaleTageBereit = '1';

    var varianten = Array.prototype.slice.call(wurzel.querySelectorAll('[data-hpn-variante]'));
    var standard = null;
    var tage = [];
    varianten.forEach(function (v) {
      if (v.dataset.hpnVariante === 'standard') standard = v; else tage.push(v);
    });
    var editorAuswahl = null;

    function waehlen() {
      if (editorAuswahl) return editorAuswahl;
      if (erzwungenerTag) {
        var gesucht = erzwungenerTag.replace(/\.?$/, '.');
        for (var i = 0; i < tage.length; i++) {
          if (tage[i].dataset.tag === gesucht) return tage[i];
        }
      }
      var s = jetztSekunden();
      for (var j = 0; j < tage.length; j++) {
        var start = Number(tage[j].dataset.start);
        var ende = Number(tage[j].dataset.ende);
        if (start > 0 && s >= start && s < ende) return tage[j];
      }
      return standard;
    }

    function zeigen() {
      var ziel = waehlen();
      if (!ziel) return;
      varianten.forEach(function (v) {
        var an = v === ziel;
        if (v.hidden === !an) return;
        v.hidden = !an;
        if (an) {
          /* Bilder der bisher versteckten Variante sofort laden. */
          v.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
            img.loading = 'eager';
          });
        }
      });
    }

    zeigen();

    /* Ein offener Tab wechselt um Mitternacht mit, ohne neu zu laden. Bei
       den Vorschau-Parametern bleibt die Anzeige stehen. */
    if (!erzwungenerTag && isNaN(simulierteMs)) {
      window.setInterval(zeigen, 30000);
    }

    document.addEventListener('shopify:block:select', function (e) {
      var id = e.detail && e.detail.blockId;
      for (var k = 0; k < tage.length; k++) {
        if (tage[k].dataset.hpnVariante === id) {
          editorAuswahl = tage[k];
          zeigen();
          return;
        }
      }
    });

    document.addEventListener('shopify:block:deselect', function () {
      editorAuswahl = null;
      zeigen();
    });
  }

  function alleEinrichten() {
    document.querySelectorAll('[data-hpn-sale-tage]').forEach(einrichten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alleEinrichten);
  } else {
    alleEinrichten();
  }

  /* Theme-Editor: die Section wird beim Bearbeiten neu gerendert. */
  document.addEventListener('shopify:section:load', function (e) {
    einrichten(e.target.querySelector('[data-hpn-sale-tage]'));
  });
})();
